import React from "react"
import Layout from "../components/layout/layout"
import { Container, Row, Col, Card, Image } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"
import LazyLoad from "react-lazy-load"
import ExpertiseImg from '../images/expertise.svg'
import ProcessImg from '../images/process.svg'
import TransparencyImg from '../images/transparency.svg'
import BulbImg from '../images/bulb.svg'
import SupportImg from '../images/support.svg'
import CustomerSatisfactionImg from '../images/customer-satisfaction.svg'


import Seo from "../components/seo"
import { AboutMeta } from "../data/metaData"
import { Link } from "gatsby"
const BlogList = React.lazy(() => import('../components/blog-list'))

export const Head = () => (
  <Seo
    title={AboutMeta.metaTitle}
    description={AboutMeta.metaDescription}
    ogImage={AboutMeta.ogImage}
    twitterImage={AboutMeta.twitterImage}
  />
)
// markup
const About = () => {

  const AboutOurstoryBanner = "../images/about-banner-img.png"
  const RahulImg = "../images/about-us-rahul.png"
  const MissionVisionImg = "../images/about-mission-vision-img.png"

  return (
    <>
      <Layout>
        <section
          className="section banner-background d-md-flex align-items-center">
          <Container className="pt-5 mt-lg-5">
            <Row className="align-items-center g-5">
              <Col lg={6} className="py-lg-5">
                <div className="banner-content">
                  <p>ABOUT Scan ‘N’ Thru</p>
                  <h1 className="title mb-4-lg font-size-64">
                    <span className="text-primary fw-bold"> Self-checkout </span>
                    solution for retailers
                  </h1>
                  <p className="mb-0 max-width-650">
                    Transform your retail store with our cutting-edge self-checkout solution and join the forefront of retail innovation.
                  </p>
                  <Link
                    to="/contact-us"
                    className="btn btn-lg btn-primary-theme btn-240 mt-4 mt-lg-5"
                  >
                    <span>Request a demo</span>
                  </Link>
                </div>
              </Col>
              <Col lg={6} className="text-center">
                <LazyLoad offsetVertical={1000}>
                  <StaticImage
                    loading="lazy"
                    src={AboutOurstoryBanner}
                    width={624}
                    height={624}
                    alt="About Our Story Banner"
                  />
                </LazyLoad>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section">
          <Container>
            <Row className="g-5 g-lg-0 align-items-center py-5" xs={1}>
              <Col lg={7}>
                <StaticImage
                  loading="lazy"
                  src={MissionVisionImg}
                  width={864}
                  height={550}
                  alt="Rahul"
                />
              </Col>
              <Col lg={5}>
                <Card className="shadow-card">
                  <Card.Body className="p-5">
                    <div className="border-bottom mb-4 pb-4">
                      <h3 className="mb-3">Our Vision</h3>
                      <p className="mb-0">
                        We envision a future where shopping is a hassle-free and enjoyable experience for everyone.
                      </p>
                    </div>
                    <h3 className="mb-3">Our Mission</h3>
                    <p className="mb-0">
                      Empower retailers with advanced self-checkout solutions to enhance efficiency and customer satisfaction.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section bg-light">
          <Container className="py-5">
            <Row className="g-5 align-items-center text-center text-lg-start">
              <Col lg={4}>
                <div className="leader-box-image">
                  <a href="https://in.linkedin.com/in/rahul-patel-29a7b818" className="linkedin-icon" aria-label="linkedin" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-linkedin"></i></a>
                  <LazyLoad offsetVertical={1000}>
                    <StaticImage
                      loading="lazy"
                      src={RahulImg}
                      width={383}
                      height={329}
                      alt="Rahul"
                    />
                  </LazyLoad>
                </div>
              </Col>
              <Col lg={8}>
                <div className="section-title">
                  <h2 className="heading mb-4">
                    Our leadership
                  </h2>
                  <p>
                    Scan ‘N’ Thru is led by Rahul - a visionary individual whose impact on the payment industry is nothing short of transformative.
                    With nearly two decades of experience, he possesses an unparalleled understanding of the retail ecosystem's intricacies.
                    Rahul's leadership philosophy is rooted in a perfect blend of strategic foresight and hands-on industry knowledge. This unique combination has propelled Scan ‘N’ Thru to the forefront of the scan and pay revolution.
                    Under Rahul’s guidance, Scan ‘N’ Thru will continue to push boundaries, challenge conventions, and deliver solutions that empower businesses to thrive in a world that is increasingly becoming digital.
                  </p>
                  <div className="mt-4">
                    <h3 className="font-size-24 text-secondary mb-1">Rahul Patel</h3>
                    <p className="font-size-18 fw-semibold text-dark mb-0">CEO</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section">
          <Container className="py-5">
            <div className="w-75 mx-auto text-center">
              <div className="section-title mb-5 pb-1">
                <h2 className="heading mb-0">
                  Why choose Scan ‘N’ Thru?
                </h2>
              </div>
            </div>
            <Row className="g-4" xs={1} md={2} lg={3}>
              <Col>
                <div className="gray-card-box equal-height">
                  <div className="icon icon-size-70 rounded-3 mb-4 bg-white d-flex align-items-center justify-content-center">
                    <Image loading="lazy" className="lazyload" src={ExpertiseImg} alt="ExpertiseImg" />
                  </div>
                  <h3 className="h4 mb-3 fw-semibold text-primary-blue">Expertise</h3>
                  <p className="mb-0">
                    We have gained expertise by working with the top FinTech companies across the globe.
                  </p>
                </div>
              </Col>
              <Col>
                <div className="gray-card-box equal-height">
                  <div className="icon icon-size-70 rounded-3 mb-4 bg-white d-flex align-items-center justify-content-center">
                    <Image loading="lazy" className="lazyload" src={ProcessImg} alt="ProcessImg" />
                  </div>
                  <h3 className="h4 mb-3 fw-semibold text-primary-blue">Highly process oriented</h3>
                  <p className="mb-0">
                    We have a well-defined process for all our tasks that helps in maintaining the holistic view of the projects.
                  </p>
                </div>
              </Col>
              <Col>
                <div className="gray-card-box equal-height">
                  <div className="icon icon-size-70 rounded-3 mb-4 bg-white d-flex align-items-center justify-content-center">
                    <Image loading="lazy" className="lazyload" src={TransparencyImg} alt="ProcessImg" />
                  </div>
                  <h3 className="h4 mb-3 fw-semibold text-primary-blue">100% transparency</h3>
                  <p className="mb-0">
                    Keeping 100% transparency is our mantra as we keep all the unexpected surprises away from you.
                  </p>
                </div>
              </Col>
              <Col>
                <div className="gray-card-box equal-height">
                  <div className="icon icon-size-70 rounded-3 mb-4 bg-white d-flex align-items-center justify-content-center">
                    <Image loading="lazy" className="lazyload" src={BulbImg} alt="ProcessImg" />
                  </div>
                  <h3 className="h4 mb-3 fw-semibold text-primary-blue">Peace of mind</h3>
                  <p className="mb-0">
                    Our dedicated team ensures that your project is completed timely to ensure peace of mind.
                  </p>
                </div>
              </Col>
              <Col>
                <div className="gray-card-box equal-height">
                  <div className="icon icon-size-70 rounded-3 mb-4 bg-white d-flex align-items-center justify-content-center">
                    <Image loading="lazy" className="lazyload" src={SupportImg} alt="ProcessImg" />
                  </div>
                  <h3 className="h4 mb-3 fw-semibold text-primary-blue">Committed support</h3>
                  <p className="mb-0">
                    Our team is always committed to providing you with prompt support via calls, email, or chat.
                  </p>
                </div>
              </Col>
              <Col>
                <div className="gray-card-box equal-height">
                  <div className="icon icon-size-70 rounded-3 mb-4 bg-white d-flex align-items-center justify-content-center">
                    <Image loading="lazy" className="lazyload" src={CustomerSatisfactionImg} alt="ProcessImg" />
                  </div>
                  <h3 className="h4 mb-3 fw-semibold text-primary-blue">Customer satisfaction</h3>
                  <p className="mb-0">
                    Customer satisfaction is always our top priority and we ensure that by fulfilling all our client’s requirements.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section bg-dark-blue">
          <Container className="py-5">
            <Row xs={1} sm={2} className="align-items-center g-4 text-center text-sm-start">
              <Col>
                <div className="section-title">
                  <h2 className="heading text-white mb-4">
                    We are happy to <span className="text-primary fw-bold">help you!</span>
                  </h2>
                  <p className="mb-0 opacity-50 text-white">
                    Choose Scan ‘N’ Thru for effortless self-checkout. Our solution streamlines transactions and improves customer satisfaction with easy scanning and payment.
                  </p>
                </div>
              </Col>
              <Col className="text-sm-end">
                <Link to="/contact-us" className="btn btn-lg btn-primary-theme">
                  <span>Request a demo</span>
                </Link>
              </Col>
            </Row>
          </Container>
        </section>
        <BlogList sectionClass="bg-light" />
      </Layout >
    </>
  )
}

export default About
